import React, { useEffect, useState } from 'react';
import { Button, Table, Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { fetch } from '~helpers/graphql';
import { getPropertiesByLandlordSlug } from '~settings/queries';
import { formatSimpleParams } from '~helpers/params';
import { bookingJourneyType } from 'common/constants/booking';
import { allPaymentMethod } from '~constants/landlord';
import BulkEditApCategoryModal from './bulkEditApCategory';
import { PaymentPlanCategory, apCategoryType } from '~constants/landlord';

const BulkEditModal = ({ visible, t, propertyFilter, handleCloseModal, getPropertyTabData }) => {
  const [showBulkEditModal, setShowBulkEditModal] = useState(visible);
  const [selectedRowInfo, setSelectedRowInfo] = useState([]);
  const [isShowEditApCategoryModal, setIsShowEditApCategoryModal] = useState(false);
  const params = formatSimpleParams(
    {
      pageNumber: 1,
      pageSize: 50,
      citySlug: null,
      countrySlug: null,
      landlordSlug: null,
      statuses: null,
      slugs: null,
      bookNowEnable: null,
      countrySlugs: null,
      bookingJourneys: null,
    },
    propertyFilter,
  );

  const [propertiesData, setPropertiesData] = useState(null);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const columns = [
    {
      title: t('cms.landlord.property_related.property_name.table'),
      dataIndex: 'name',

      key: 'name',
      render: name => name || '-',
    },
    {
      title: t('cms.landlord.detail.ap_category.label'),
      dataIndex: 'apCategory',
      key: 'apCategory',
      render: (text, record) => {
        if (
          record.bookingJourney === bookingJourneyType.MANUAL ||
          record.bookingJourney === bookingJourneyType.FULL_AUTOMATIC
        ) {
          return t('cms.landlord.property.not_applicable');
        } else {
          return record?.apCategory
            ? t(`cms.landlord.modal.ap_category.${record.apCategory?.toLowerCase()}.option`)
            : '-';
        }
      },
    },
    {
      title: t('cms.landlord.detail.ap_category.deposit'),
      dataIndex: 'depositTransferTime',
      key: 'depositTransferTime',
      render: (text, record) => {
        if (
          record.bookingJourney === bookingJourneyType.MANUAL ||
          record.bookingJourney === bookingJourneyType.FULL_AUTOMATIC
        ) {
          return t('cms.landlord.property.not_applicable');
        } else {
          return record?.depositTransferTime
            ? t(
                `cms.landlord.detail.ap_category.deposit.${record.depositTransferTime?.toLowerCase()}`,
              )
            : '-';
        }
      },
    },
    {
      title: t('cms.landlord.detail.ap_category.rent'),
      dataIndex: 'rentTransferTime',
      key: 'rentTransferTime',
      render: (text, record) => {
        if (
          record.bookingJourney === bookingJourneyType.MANUAL ||
          record.bookingJourney === bookingJourneyType.FULL_AUTOMATIC
        ) {
          return t('cms.landlord.property.not_applicable');
        } else {
          return record?.rentTransferTime
            ? t(`cms.landlord.detail.ap_category.rent.${record.rentTransferTime.toLowerCase()}`)
            : '-';
        }
      },
    },
  ];
  const handleContinue = () => {
    setShowBulkEditModal(false);
    setIsShowEditApCategoryModal(true);
  };
  const getInitData = newParams => {
    setLoading(true);
    fetch(getPropertiesByLandlordSlug(Object.assign({}, params, newParams))).then(res => {
      if (res?.properties?.edges) {
        setDataCount(res?.properties?.totalCount ?? 0);
        const data = [];
        const selectedRows = [];
        res?.properties?.edges?.map(item => {
          if (
            item?.node?.withdrawMthod?.methodType === allPaymentMethod.STRIPE ||
            (item?.node?.paymentPlan?.category === PaymentPlanCategory.DEPOSIT_IS_REQUIRED &&
              item?.node?.apCategory === apCategoryType.KEY)
          ) {
            data.push(item?.node);
          } else {
            data.push(item?.node);
            selectedRows.push(item?.node);
          }
        });
        setPropertiesData(data);
        setSelectedRowInfo(selectedRows);
      }
      setLoading(false);
    });
  };

  const handleTableChange = pagination => {
    getInitData({
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    });
  };
  useEffect(() => {
    if (visible) {
      setShowBulkEditModal(true);
      getInitData();
    } else {
      setShowBulkEditModal(false);
    }
  }, [visible]);
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowInfo(selectedRows);
    },
    getCheckboxProps: record => ({
      disabled:
        record.withdrawMthod?.methodType === allPaymentMethod.STRIPE ||
        (record?.paymentPlan?.category === PaymentPlanCategory.DEPOSIT_IS_REQUIRED &&
          record?.apCategory === apCategoryType.KEY), // Column configuration not to be checked

      defaultChecked:
        record.withdrawMthod?.methodType !== allPaymentMethod.STRIPE &&
        !(
          record?.paymentPlan?.category === PaymentPlanCategory.DEPOSIT_IS_REQUIRED &&
          record?.apCategory === apCategoryType.KEY
        ),
      name: record.name,
    }),
  };

  const isDepositOnly = propertiesData?.some(
    property =>
      property?.apCategory === apCategoryType.KEY &&
      property?.paymentPlan?.category === PaymentPlanCategory.DEPOSIT_IS_REQUIRED,
  );

  const isStripePayment = propertiesData?.some(
    property => property?.withdrawMthod?.methodType === allPaymentMethod.STRIPE,
  );

  const isStripePaymentAndDepositOnly = propertiesData?.some(
    property =>
      property?.withdrawMthod?.methodType === allPaymentMethod.STRIPE &&
      property?.apCategory === apCategoryType.KEY &&
      property?.paymentPlan?.category === PaymentPlanCategory.DEPOSIT_IS_REQUIRED,
  );

  return (
    <div>
      <Modal
        centered
        visible={showBulkEditModal}
        title={''}
        footer={[
          <div className={'bulk-edit__editContainer'}>
            <div className="bulk-edit__modal-button_text">
              <If condition={!!selectedRowInfo?.length}>
                {t('cms.properties_bulk_operation_confirm.modal.operation.selected_num', {
                  num: selectedRowInfo?.length,
                })}
              </If>{' '}
            </div>
            <div>
              <Button onClick={handleCloseModal} size="large" style={{ marginRight: '8px' }}>
                {t('cms.properties.change_log.filter_modal.btn.cancel')}
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={handleContinue}
                disabled={!selectedRowInfo?.length}
                style={{ fontWeight: 600 }}
              >
                {t('cms.sepcial_offer.continue.btn')}
              </Button>
            </div>
          </div>,
        ]}
        width={820}
        className="bulk-edit__modal"
        onCancel={handleCloseModal}
      >
        <div className="bulk-edit__modal-title">{t('cms.landlord.property.bulk_edit_title')}</div>
        <p>{t('cms.landlord.property.bulk_edit_hint')}</p>
        <div className="bulk-edit__hint-box">
          <div className="bulk-edit__stripe-hint">
            <ExclamationCircleFilled className="bulk-edit__stripe-hint__icon" />
            <p className="bulk-edit__stripe-hint__content">
              {t('cms.landlord.property.bulk_edit.first.hint')}
            </p>
          </div>

          <div>
            <ul style={{ margin: 0, marginLeft: '32px', padding: 0 }}>
              <If condition={!isStripePaymentAndDepositOnly}>
                {/* 只有StripePayment */}
                <If condition={isStripePayment && !isDepositOnly}>
                  <li className="bulk-edit__stripe-hint__content">
                    {t('cms.landlord.property.bulk_type_hint')}
                  </li>
                </If>
                {/* 既没有StripePayment也没DepositOnly但有property数据 */}
                <If
                  condition={
                    !isStripePayment && !isDepositOnly && propertiesData && propertiesData?.length
                  }
                >
                  <li className="bulk-edit__stripe-hint__content">
                    {t('cms.landlord.property.bulk_type_hint')}
                  </li>
                </If>
                {/* 只有deposit only */}
                <If condition={isDepositOnly && !isStripePayment}>
                  <li className="bulk-edit__stripe-hint__content">
                    {t('cms.landlord.property.bulk_deposit_only.hint')}
                  </li>
                </If>
              </If>
              {/* 既绑定了deposit也绑定了stripe */}
              <If condition={isStripePaymentAndDepositOnly || (isDepositOnly && isStripePayment)}>
                <li className="bulk-edit__stripe-hint__content">
                  {t('cms.landlord.property.bulk_type_hint')}
                </li>
                <li className="bulk-edit__stripe-hint__content">
                  {t('cms.landlord.property.bulk_deposit_only.hint')}
                </li>
              </If>
              {/* property数据为空时 */}
              <If condition={propertiesData && !propertiesData?.length}>
                <li className="bulk-edit__stripe-hint__content">
                  {t('cms.landlord.property.bulk_empty_hint')}
                </li>
              </If>
            </ul>
          </div>
        </div>

        <div className="bulk-edit__table-box">
          <Table
            footer={null}
            dataSource={propertiesData}
            className="bulk-edit__table"
            columns={columns}
            loading={loading}
            rowSelection={rowSelection}
            rowKey={record => record.id}
            pagination={{
              showSizeChanger: true,
              total: dataCount,
            }}
            onChange={handleTableChange}
            rowClassName={record =>
              (record.withdrawMthod?.methodType === allPaymentMethod.STRIPE ||
                (record?.paymentPlan?.category === PaymentPlanCategory.DEPOSIT_IS_REQUIRED &&
                  record?.apCategory === apCategoryType.KEY)) &&
              'disabled-row'
            }
          />
        </div>
      </Modal>
      <If condition={isShowEditApCategoryModal}>
        <BulkEditApCategoryModal
          showBulkModal={() => {
            setShowBulkEditModal(true);
            setIsShowEditApCategoryModal(false);
          }}
          closeModal={() => {
            handleCloseModal();
            setIsShowEditApCategoryModal(false);
          }}
          visible={isShowEditApCategoryModal}
          t={t}
          selectedRowInfo={selectedRowInfo}
          getPropertyTabData={getPropertyTabData}
        />
      </If>
    </div>
  );
};
BulkEditModal.displayName = 'BulkEditModal';
export default BulkEditModal;
